import type { VisitWithFields } from "@/api/visits";
import { useI18n } from "vue-i18n";
import { VisitFieldTypes } from "@/api/zoolander";
import { VACCINE_PASS_TYPE, type VaccinePass } from "@/api/visitorFields";

export const useVisitField = () => {
  const { t } = useI18n();

  const visitFieldValue = (fieldPk: string, visit?: VisitWithFields) => {
    const field = visit?.fields?.find(({ id }) => id === fieldPk);

    const value = field?.value;
    if (!value && field?.fieldType !== VisitFieldTypes.Document)
      return { value: t("emptyValue") };

    switch (field?.fieldType) {
      case VisitFieldTypes.Multiselect:
        return { isArray: true, value };
      case VisitFieldTypes.Document: {
        return {
          value: value
            ? t("visitors.fields.documentUploaded")
            : t("visitors.fields.noDocumentProvided"),
          isDocument: value,
          url: field.url,
        };
      }
      case VisitFieldTypes.Vaccinepass: {
        const vaccineField = value as unknown as VaccinePass;
        if (vaccineField.type === VACCINE_PASS_TYPE.PROVIDED) {
          return {
            value: vaccineField.result?.success
              ? t("visitors.fields.passValidated")
              : t("visitors.fields.passInvalid"),
          };
        } else if (
          [VACCINE_PASS_TYPE.SKIPPED, VACCINE_PASS_TYPE.EMPTY].includes(
            vaccineField.type
          )
        ) {
          return { value: t("visitors.fields.passNotProvided") };
        }
        return { value: t("emptyValue") };
      }
      default:
        return { value: value };
    }
  };

  return { visitFieldValue };
};
